// extracted by mini-css-extract-plugin
export var avatarContainer = "_3w-1";
export var largeAvatarContainer = "_3w-2";
export var smallAvatarContainer = "_3w-0";